
import { IPerformanceReport } from './../../Models/PerformanceReport';
import { Reducer, combineReducers } from 'redux';
import {
  PerformanceReportAction,  
  SAVE_PERFORMANCEREPORT_SUCCESS,
  SUBMIT_PERFORMANCEREPORT_SUCCESS,
  UPDATE_PERFORMANCEREPORT_ITEM_VALUE,
  SAVE_PERFORMANCEREPORT,
  SET_SELECTED_CLIENT_ID,
  CLEAR_LOADING_REPORT,
  SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS,
  LOAD_COMPLETED_PERFORMANCEREPORT_TABS_SUCCESS,
  UNLOCK_PERFORMANCEREPORT_SUCCESS,
  LOAD_DEALER_REPORTS_SUCCESS,
  LOAD_ALL_DEALER_REPORTS_SUCCESS,
  CLOSE_PERFORMANCE_REPORT,
  LOAD_PERFORMANCE_REPORT,
  LOAD_PERFORMANCE_REPORT_SUCCESS,
  CREATE_PERFORMANCE_REPORT,
  CREATE_PERFORMANCE_REPORT_SUCCESS,
  ROLLUP_PERFORMANCEREPORT,
  ROLLUP_PERFORMANCEREPORT_SUCCESS,
  ROLLUP_PERFORMANCEREPORT_FAILURE,
} from './actions';
import { append, reject } from 'ramda';
import { DealerReport } from '../../Models/DealerReport';

export interface PerformanceReportState {
  performanceReport : IPerformanceReport | null;
  loadingPerformanceReport: boolean;
  savingPerformanceReport: boolean;
  selectedClientId: string | null;
  dealerReports: DealerReport[];
  completedCategories: string[];
}
const INITIAL_STATE: PerformanceReportState = {
  performanceReport : null,
  loadingPerformanceReport: false,
  savingPerformanceReport: false,
  selectedClientId: null,
  completedCategories: [],
  dealerReports: []
};

const performanceReportsReducer = (state: IPerformanceReport | null = INITIAL_STATE.performanceReport, action: PerformanceReportAction): IPerformanceReport | null => {
  switch(action.type) {
    case LOAD_PERFORMANCE_REPORT:
    case CREATE_PERFORMANCE_REPORT:
      return INITIAL_STATE.performanceReport;
    case LOAD_PERFORMANCE_REPORT_SUCCESS:
    case CREATE_PERFORMANCE_REPORT_SUCCESS:
      return action.payload.performanceReport;
    case SAVE_PERFORMANCEREPORT_SUCCESS:
    case SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS:
      return action.payload.performanceReport;
    case SUBMIT_PERFORMANCEREPORT_SUCCESS:
    case UNLOCK_PERFORMANCEREPORT_SUCCESS:
      return action.payload.performanceReport;
    case UPDATE_PERFORMANCEREPORT_ITEM_VALUE:
      if(state !== null) {
        return {
          ...state,
          performanceReportItemValues: state.performanceReportItemValues.map(pi => {
            if(pi.id === action.payload.itemId) {
              if(action.payload.fieldName !== 'notes' && (!action.payload.value || action.payload.value === '' || Number.isNaN(action.payload.value))){
                return {
                  ...pi,
                  value: 0,
                  notes: pi.notes,
                };
              }

              return {
                ...pi,
                value: action.payload.fieldName === "value" ? action.payload.value as number: pi.value,
                notes: action.payload.fieldName === "notes" ? (action.payload.value ?? '') as string : pi.notes,
              };
            }
            return pi;
          })
        }
      }
      return state;
    case SET_SELECTED_CLIENT_ID:
      return INITIAL_STATE.performanceReport;
    case CLOSE_PERFORMANCE_REPORT:
      return INITIAL_STATE.performanceReport;
    default:
      return state;
    case ROLLUP_PERFORMANCEREPORT:
      return state;
    case ROLLUP_PERFORMANCEREPORT_SUCCESS:
    case ROLLUP_PERFORMANCEREPORT_FAILURE:
      return state;  
  }
}

const dealerReportsReducer = (state: DealerReport[] = INITIAL_STATE.dealerReports, action: PerformanceReportAction): DealerReport[] => {
  switch(action.type) {
    case LOAD_DEALER_REPORTS_SUCCESS:
    case LOAD_ALL_DEALER_REPORTS_SUCCESS:
      return action.payload.dealerReports;
    default:
      return state;
  }
}

const loadingPerformanceReportReducer = (state: boolean = INITIAL_STATE.loadingPerformanceReport, action: PerformanceReportAction) : boolean => {
  switch(action.type) {
    case LOAD_PERFORMANCE_REPORT:
    case CREATE_PERFORMANCE_REPORT:
      return true;
    case CREATE_PERFORMANCE_REPORT_SUCCESS:
    case LOAD_PERFORMANCE_REPORT_SUCCESS:
    case CLEAR_LOADING_REPORT:
      return false;
    default: 
      return state;
  }
}
const savingPerformanceReportReducer = (state: boolean = INITIAL_STATE.savingPerformanceReport, action: PerformanceReportAction) : boolean => {
  switch(action.type) {
    case SAVE_PERFORMANCEREPORT:
      return true;
    case SAVE_PERFORMANCEREPORT_SUCCESS:
      return false;
    default: 
      return state;
  }
}
const selectedClientIdReducer = (state: string | null = INITIAL_STATE.selectedClientId, action: PerformanceReportAction) : string | null => {
  switch(action.type) {
    case SET_SELECTED_CLIENT_ID: 
      return action.payload.clientId;
    default:
      return state;
  }
}

const completedCategoriesReducer = (state: string[] = INITIAL_STATE.completedCategories, action: PerformanceReportAction) : string[] => {
  switch(action.type) {
    case LOAD_COMPLETED_PERFORMANCEREPORT_TABS_SUCCESS:
      return action.payload.completedCategoryIds || [];
    case SUBMIT_PERFORMANCEREPORT_TAB_SUCCESS: 
      if( action.payload.includeStatus){
        return append(action.payload.categoryId, state);
      }
      return reject(c => c === action.payload.categoryId, state);
    default:
      return state;
  }
}

export const performanceReportReducer: Reducer<PerformanceReportState> = combineReducers<PerformanceReportState>({
  performanceReport: performanceReportsReducer,
  loadingPerformanceReport: loadingPerformanceReportReducer,
  savingPerformanceReport: savingPerformanceReportReducer,
  selectedClientId: selectedClientIdReducer,
  completedCategories: completedCategoriesReducer,
  dealerReports: dealerReportsReducer
});
